import { ProductResponse } from './product.model';
import { WarehouseResponse } from './warehouse.model';

export class ProductFavoriteResponse {
    id: number;
    company: number;
    createdBy: number;
    creationDate: any;

    product: ProductResponse;
    warehouse: WarehouseResponse;
}

export class ProductFavoriteRequest {
    productId: number;
    warehouseId: number;
}